<template>
  <div>
    <slider/>
  

  </div>
</template>
<script>
import slider from '../components/slider.vue'

export default {
  components: { slider },
  name: 'Index',
  mounted: function () {
    document.body.classList.remove('inner-page')
  }
}
</script>
